import react, { useEffect } from 'react'
import { getEvents } from '../../../../store/adminActions'
import { useAppSelector, useAppDispatch } from '../../../../store/hooks/hooks'
import Calender from '../../../studentDashboard/calender/calender'
import EventList from '../../meetings/eventsList/eventList'

const Events = () => {
    const events = useAppSelector((state: any) => state.admin.events)
    const dispatch = useAppDispatch()
    const fetchEventList = async () => {
        await dispatch(getEvents("all"))
    }
    useEffect(() => {
        fetchEventList()
    }, [])

    return (
        <div className='h-100'>
            <div className='h-100'>
                <EventList events={events} ></EventList>
            </div>
        </div>
    )

}
export default Events